import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { getColorForTheme } from '../utils'

const ProfilePicture = ({ brandColor, url }) => {
  if (url) {
    return (
      <Fragment>
        <circle fill='url(#brandImage)' cx={13.369} cy={13.418} r={13.418} />
        <pattern id='brandImage' x='0%' y='0%' height='100%' width='100%' viewBox='0 0 512 512'>
          <image x='0%' y='0%' width='512' height='512' href={url} preserveAspectRatio='xMidYMid slice' />
        </pattern>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <ellipse fill={brandColor} cx={13.369} cy={13.418} rx={13.369} ry={13.418} />
      <g fill='#FFF'>
        <path d='M13.499 22 7 17.2v-2.4l3.742.84 2.76 3.818 2.755-3.819L20 14.801H20v2.398z' />
        <path d='M7 9.217v5.584l6.5-3.634S8.63 8.349 8.212 8.183C7.431 7.867 7 7.82 7 9.217Z' />
        <path d='M18.786 8.183c-.416.166-5.272 2.975-5.272 2.975l-6.513 3.643 3.742.838 2.756 3.819 2.761-3.819 3.74-.838V9.217c0-1.397-.431-1.35-1.214-1.034Z' />
      </g>
    </Fragment>
  )
}

const MaximizedWidgetPreview = ({ brandImageUrl }) => {
  const { watch } = useFormContext()

  const displayName = watch('displayName')
  const brandColor = watch('brandColor')
  const textColorTheme = watch('textColor')
  const textColor = getColorForTheme(textColorTheme)

  return (
    <svg transform='translate(0,50)' width={355} height={665} xmlns='http://www.w3.org/2000/svg'>
      <title>Widget</title>
      <g fill='none' fillRule='evenodd'>
        <path
          d='M24 0h306c13.255 0 24 10.745 24 24v547c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V24C0 10.745 10.745 0 24 0Z'
          fill='#FFF'
          fillRule='nonzero'
        />
        <g transform='translate(10 80)' fillRule='nonzero'>
          <ProfilePicture brandColor={brandColor} url={brandImageUrl} />
        </g>
        <g transform='translate(10 220)' fillRule='nonzero'>
          <ProfilePicture brandColor={brandColor} url={brandImageUrl} />
        </g>
        <text
          transform='translate(299.663 193.73)'
          opacity={0.5}
          fill='#000'
          fillRule='nonzero'
          fontFamily='ArialMT, Arial'
          fontSize={9}
        >
          <tspan x={0} y={8}>
            02:30 PM
          </tspan>
        </text>
        <path
          d='M220 145h116.337a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H220a8 8 0 0 1-8-8v-24a8 8 0 0 1 8-8Z'
          fill={brandColor}
          fillRule='nonzero'
        />
        <text
          transform='translate(223 157)'
          fill={textColor}
          fillRule='nonzero'
          fontFamily='ArialMT, Arial'
          fontSize={13}
        >
          <tspan x={0.316} y={12}>
            Start RMA process
          </tspan>
        </text>
        <path
          d='M251.497 80c4.696 0 8.503 3.582 8.503 8v19.12c0 4.418-3.807 8-8.503 8H54.503c-4.696 0-8.503-3.582-8.503-8V80h205.497ZM311.89 220c4.734 0 8.572 3.582 8.572 8v74c0 4.418-3.838 8-8.572 8H55.033c-4.734 0-8.571-3.582-8.571-8v-82H311.89Z'
          fill='#F1F0F0'
          fillRule='nonzero'
        />
        <rect
          strokeOpacity={0.8}
          stroke={brandColor}
          fillOpacity={0.05}
          fill={brandColor}
          fillRule='nonzero'
          x={46}
          y={322}
          width={214}
          height={32}
          rx={8}
        />
        <rect
          strokeOpacity={0.8}
          stroke={brandColor}
          fillOpacity={0.05}
          fill={brandColor}
          fillRule='nonzero'
          x={46}
          y={363}
          width={199.646}
          height={32}
          rx={8}
        />
        <text
          transform='translate(56 331)'
          opacity={0.9}
          fill='#000'
          fillRule='nonzero'
          fontFamily='ArialMT, Arial'
          fontSize={13}
        >
          <tspan x={0} y={12}>
            Step 1: Screen customer location
          </tspan>
        </text>
        <text
          transform='translate(56 371)'
          opacity={0.9}
          fill='#000'
          fillRule='nonzero'
          fontFamily='ArialMT, Arial'
          fontSize={13}
        >
          <tspan x={0} y={12}>
            Step 2: Generate an RMA link
          </tspan>
        </text>
        <text transform='translate(60.462 88)' fill='#000' fillRule='nonzero' fontFamily='ArialMT, Arial' fontSize={13}>
          <tspan x={0} y={12}>
            Hi! What do you need help with?
          </tspan>
        </text>
        <text
          transform='translate(60.462 233)'
          fill='#000'
          fillRule='nonzero'
          fontFamily='ArialMT, Arial'
          fontSize={13}
        >
          <tspan x={0} y={12}>
            Here are the key steps available in the
          </tspan>
          <tspan x={0} y={31}>
            consumer RMA process. Choose the one
          </tspan>
          <tspan x={0} y={50}>
            {'you need help with, or select \u2018More Topics\u2019.'}
          </tspan>
        </text>
        <text
          transform='translate(46.462 119.68)'
          opacity={0.5}
          fill='#000'
          fillRule='nonzero'
          fontFamily='ArialMT, Arial'
          fontSize={9}
        >
          <tspan x={0} y={8}>
            02:30 PM
          </tspan>
        </text>
        <path
          d='M331 0c13.255 0 24 10.745 24 24v18.61h-51.435v.041H24c-13.122 0-23.785 10.531-24 23.603v.397V24C0 10.745 10.745 0 24 0h307Z'
          fill={brandColor}
          fillRule='nonzero'
        />
        <foreignObject width={268} height={67}>
          <div
            style={{
              padding: '12px 20px',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              color: textColor
            }}
          >
            {displayName}
          </div>
        </foreignObject>

        <path
          d='M298.107 23.004C299.004 23.004 299.739 22.265 299.739 21.361C299.739 20.458 299.004 19.718 298.107 19.718C297.209 19.718 296.475 20.458 296.475 21.361C296.475 22.265 297.209 23.004 298.107 23.004ZM286.683 23.004C287.58 23.004 288.315 22.265 288.315 21.361C288.315 20.458 287.58 19.718 286.683 19.718C285.785 19.718 285.051 20.458 285.051 21.361C285.051 22.265 285.785 23.004 286.683 23.004ZM292.395 23.004C293.292 23.004 294.027 22.265 294.027 21.361C294.027 20.458 293.292 19.718 292.395 19.718C291.497 19.718 290.763 20.458 290.763 21.361C290.763 22.265 291.497 23.004 292.395 23.004Z'
          fill={textColor}
        />

        <path
          d='M319 22.5C318.448 22.5 318 21.9404 318 21.25C318 20.5596 318.448 20 319 20H329.448C330 20 330.448 20.5596 330.448 21.25C330.448 21.9404 330 22.5 329.448 22.5H319Z'
          fill={textColor}
        />

        <text
          transform='translate(46 402)'
          opacity={0.5}
          fill='#000'
          fillRule='nonzero'
          fontFamily='ArialMT, Arial'
          fontSize={9}
        >
          <tspan x={0} y={8}>
            02:30 PM
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default MaximizedWidgetPreview
